import { useState, useEffect } from 'react';

export const DEFAULT_PAYMENT_MODES = [
    { name: 'Cash', enabled: 1, type: 'Cash' },
    { name: 'Card', enabled: 1, type: 'Bank' },
    { name: 'InstaPay', enabled: 0, type: 'Bank' },
    { name: 'Credit', enabled: 1, type: 'Credit' },
    { name: 'Bank', enabled: 1, type: 'Bank' },
    { name: 'Cheque', enabled: 1, type: 'Bank' },
    { name: 'Wire Transfer', enabled: 1, type: 'Bank' }
];

export const getEnabledPaymentModes = () => {
    try {
        const cached = localStorage.getItem('enabled_payment_modes');
        if (cached) {
            const parsed = JSON.parse(cached);
            if (Array.isArray(parsed) && parsed.length > 0) {
                return parsed;
            }
        }
    } catch (e) {
        console.error(e);
    }
    return DEFAULT_PAYMENT_MODES;
};

export const isPaymentModeEnabled = (modeName) => {
    if (!modeName) return false;
    const modes = getEnabledPaymentModes();
    const target = modeName.toLowerCase().trim();
    const found = modes.find(m => 
        (m.name || '').toLowerCase().trim() === target ||
        (target === 'card' && (m.name || '').toLowerCase().includes('card'))
    );
    return found ? (found.enabled === 1 || found.enabled === true) : false;
};

export const usePaymentModeSetting = () => {
    const [paymentModes, setPaymentModes] = useState(getEnabledPaymentModes());

    useEffect(() => {
        const handleSettingChange = () => {
            setPaymentModes(getEnabledPaymentModes());
        };

        window.addEventListener('payment_modes_changed', handleSettingChange);
        window.addEventListener('storage', handleSettingChange);

        return () => {
            window.removeEventListener('payment_modes_changed', handleSettingChange);
            window.removeEventListener('storage', handleSettingChange);
        };
    }, []);

    const activeModes = paymentModes.filter(m => m.enabled === 1 || m.enabled === true);

    return { 
        paymentModes, 
        activeModes, 
        isPaymentModeEnabled: (name) => isPaymentModeEnabled(name) 
    };
};
